/** The bare solo pages' chrome: the top bar (no round clock, no role: solo has no countdown and no CRO person) over a light page. */
import { useCallback, useState, type ReactNode } from "react";
import { useRoute } from "../api/context";
import { useSignOut } from "../auth";
import { GlossaryProvider } from "../theme/GxTerm";
import { GxTopBar } from "../shell/TopBar";
import { GxNavSheet } from "../shell/NavSheet";
import { useAccountItems } from "../shell/runs";
import { rememberBank } from "../shell/lastKnown";
import "../shell/shell.css";
import "./solo.css";

/** `runId` (a solo run is a cohort) loads the glossary so dotted terms open their popover here too. */
export function SoloFrame({ bankName, subline, runId, title = "Solo run", children }: { readonly title?: string; readonly bankName: string; readonly subline: string; readonly runId?: string; readonly children: ReactNode }) {
  const me = useRoute("authMe", undefined, { staleTime: Infinity });
  const catalog = useRoute("contentCatalog", runId === undefined ? null : { cohortId: runId }, { staleTime: Infinity });
  const signOut = useSignOut();
  const accountItems = useAccountItems();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const bank = bankName === "Governexus" ? rememberBank(undefined) ?? bankName : (rememberBank(bankName) ?? bankName);
  const name = me.data?.principal.displayName ?? "";
  return (
    <GlossaryProvider value={catalog.data?.glossary ?? []}>
      <GxTopBar bankName={bank} subline={subline} role={null} name={name} clock={null} onSignOut={signOut} accountItems={accountItems} title={title} onMenu={() => setMenuOpen(true)} menuOpen={menuOpen} />
      <main className="gx-solo-main">{children}</main>
      {menuOpen ? <GxNavSheet onClose={closeMenu} bankName={bank} subline={subline} role={null} items={[]} active="" name={name} email={me.data?.principal.email ?? null} accountItems={accountItems} onSignOut={signOut} /> : null}
    </GlossaryProvider>
  );
}
